import { NgModule } from '@angular/core';
import { GoogleClassroomGuard } from './services/google-classroom.service';

@NgModule({
  imports: [],
  providers: [GoogleClassroomGuard],
  declarations: [],
  exports: [],
})
export class GoogleClassroomModule {}
